import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Button,
  Dropdown,
  Menu,
  Badge,
  Typography,
  Progress,
  Checkbox,
  notification,
  Tooltip,
} from 'antd';
import { useHistory } from 'react-router-dom';
import {
  CustomImage,
  CustomPageHeader,
  CustomTable,
  confirmDialog,
  VehicleManagementSkeleton, useText,
  Text as CustomText
} from '@src/components';
import { useLang } from '@src/context';
import {
  getVehicleList,
  resetCurrentLoadVehicleManagement,
  getUpdateVehiclesUsableDays,
  setSelectedRowKeys,
  resetSelectedRowKeys,
  setIsSelectCheckAll,
  removeLimitRestriction,
  getUpdateVehicleDisable,
  deletePlateAllDevices,
  setSelectedRowVehicleIds,
  resetSelectedRowVehicleIds,
} from '@src/store/slice/vehicleManagementStore/vehicleManagementSlice';
import { setVehicleManagementItem } from '@src/store/slice/vehicleManagementStore/vehicleManagementDetailSlice';
import { resetVehicleLimitWithValueTypes } from '@src/store/slice/addNewCarStore/addCarPlateDetailSlice';
import { formatPlate, getFileNameByLanguage, moneyFormat } from '@src/utils/utils';
import AddVehicleLimitsListModal from './AddVehicleLimitsListModal';
import AddVehicleUsableDaysModal from './AddVehicleUsableDaysModal';

import carWallet from '@src/assets/icons/ticketcar/wallet-money.svg';
import carMoney from '@src/assets/icons/ticketcar/money-remove.svg';
import downloadPO from '@src/assets/icons/download_po.svg';
import poLOGO from '@src/assets/icons/po-logo.svg';
import filoCode from '@src/assets/icons/people.svg';
import iconSetting from '@src/assets/icons/icon-settings.svg';
import plus from '@src/assets/icons/ticketcar/add.svg';
import more from '@src/assets/icons/ticketcar/more-4.svg';
import plateDetail from '@src/assets/icons/ticketcar/plate-detail.svg';
import plateRemove from '@src/assets/icons/ticketcar/plate-remove.svg';
import plateUpdate from '@src/assets/icons/ticketcar/plate-update.svg';
import rowDetail from '@src/assets/icons/ticketcar/row-detail.svg';
import documentDownload from '@src/assets/icons/ticketcar/document-download.svg';
import gasStation from '@src/assets/icons/ticketcar/gas-station.svg';
import limitAdd from '@src/assets/icons/ticketcar/card-add.svg';
import filterButton from '@src/assets/icons/icon-task-square.svg';
import limitRemove from '@src/assets/icons/ticketcar/card-remove.svg';
import dayAdd from '@src/assets/icons/ticketcar/calendar-add.svg';
import dayRemove from '@src/assets/icons/ticketcar/calendar-remove.svg';
import car from '@src/assets/icons/ticketcar/car.svg';
import '@src/styles/vehicleManagement/vehicleManagement.scss';
import DownloadFileModal from './DownloadFileModal';
import CustomIconComponent from '@src/components/CustomIconComponent';
import CustomFilterCollapse from '@src/components/CustomFilterCollapse';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import icnUp from '@src/assets/icons/icn-up.svg';
import icnDown from '@src/assets/icons/icn-down.svg';
import vehicleManagementServices from '@src/services/vehicleManagement/vehicleManagement.services';
import download from 'js-file-download';
import { getCustomerVouList } from '@src/store/slice/customerSlice';
import { errorDialog, successDialog, warningDialog } from '@src/components/CustomDialog';
import iconBilgiSvg from '@src/assets/icons/icon-bilgi.svg';
import iconDanger from '@src/assets/icons/danger.svg';
import UTTSErrorModal from './uttsErrorModal';

const { Text } = Typography;

const VehicleManagement = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { language } = useLang();
  const {
    vehicleList = [],
    customVehicleList = [],
    loading,
    activeVehicles,
    passiveVehicles,
    providerList = null,
    statusList = null,
    deviceList = null,
    limitTypeList = null,
    limitValueTypeList = null,
    plateList = [],
    driverNameSurnameList = [],
    selectedRowKeys,
    isSelectCheckAll,
    vehicleLimit,
    vehicleAvailableLimit,
    externalId,
    selectedRowVehicleIds,
    IsBpCustomer,
  } = useSelector((state) => state.vehicleManagement);

  const [selectedProviderTypes, setSelectedProviderTypes] = useState([]);
  const [isLimitsListModalVisible, setIsLimitsListModalVisible] = useState(false);
  const [isUsableDaysModalVisible, setIsUsableDaysModalVisible] = useState(false);
  const [downloadFileModalVisible, setDownloadFileModalVisible] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [selectedPlate, setSelectedPlate] = useState('');
  const [singleRecord, setSingleRecord] = useState(null);
  const [status, setStatus] = useState(null);
  const [providers, setProviders] = useState(null);
  const [devices, setDevices] = useState(null);
  const [limitTypes, setLimitTypes] = useState(null);
  const [limitValueTypes, setLimitValueTypes] = useState(null);
  const [checkedDevices, setCheckedDevices] = useState([]);
  const [checkedProviders, setCheckedProviders] = useState([]);
  const [checkedStatus, setCheckedStatus] = useState([]);
  const [checkedLimitTypes, setCheckedLimitTypes] = useState([]);
  const [checkedLimitValueTypes, setCheckedLimitValueTypes] = useState([]);
  const [filterPlate, setFilteredPlate] = useState('');
  const [filterDriver, setFilteredDriver] = useState('');
  const [panels, setPanels] = useState([]);
  const [columns, setColumns] = useState([]);
  const [cusVouList, setCusVouList] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const completeUttsNotificationText = useText('completeUttsNotification');
  const giveUpText = useText('giveUp');
  const attentionText = useText('attention');
  const yesText = useText('yes');
  const noText = useText('no');
  const plateFilterText = useText('plate');
  const driverFilterText = useText('driver3');
  const limitTypeFilterText = useText('limitType7');
  const limitValueTypeFilterText = useText('limitType');
  const deviceTypeFilterText = useText('deviceType5');
  const providerFilterText = useText('provider');
  const statusFilterText = useText('status3');
  const removeDayRestrictionText = useText('removeDayRestriction');
  const deleteLicensePlateFromFleetText = useText('deleteLicensePlateFromFleet');
  const stopFuelPurchase2Text = useText('stopFuelPurchase2');
  const openFuelPurchase2Text = useText('openFuelPurchase2');
  const removeLimitRestriction2Text = useText('removeLimitRestriction2');
  const transactionSuccessfullyCompletedText = useText('transactionSuccessfullyCompleted2');
  const allSelectedPlatesFuelPurchaseWillBeStoppedText = useText(
    'allSelectedPlatesFuelPurchaseWillBeStopped',
  );
  const allSelectedPlatesFuelPurchaseWillBeOpenedText = useText(
    'allSelectedPlatesFuelPurchaseWillBeOpened',
  );
  const unlimited = useText('unlimited');
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const { selectedCustomer } = useSelector((state) => state.customer);
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });

  const indeterminate =
    selectedRowKeys?.length > 0 && selectedRowKeys?.length < customVehicleList.length;
  console.log('indeterminate', indeterminate);
  const fetchVehicleListData = async () => {
    if (isAdmin && selectedUserId) {
      await dispatch(getVehicleList({ customerId: selectedUserId }));
    } else {
      await dispatch(getVehicleList());
    }
  };

  useEffect(async () => {
    try {
      const vouListAction = await dispatch(
        getCustomerVouList({
          customerId: isAdmin && selectedUserId ? selectedUserId : selectedCustomer?.customerId,
          vouId: 4,
        }),
      );
      if (getCustomerVouList.fulfilled.match(vouListAction)) {
        const array = vouListAction.payload.data;
        if (array) {
          setCusVouList(array);
        }
      }
    } catch (error) {
      console.error('getCustomerVouList', error);
    }
  }, [selectedCustomer, selectedUserId, isAdmin]);

  const onSelectChange = (e, record) => {
    try {
      let newSelectedRowKeys = [...selectedRowKeys];
      const relatedVehicleDetailIds = [
        record.vehicleDetailId,
        ...(Array.isArray(record.multipleDevice)
          ? record.multipleDevice
            .map(d => d.vehicleDetailId)
            .filter(Boolean)
          : []),
      ];
      if (e.target.checked) {
        relatedVehicleDetailIds.forEach(id => {
          if (!newSelectedRowKeys.includes(id)) {
            newSelectedRowKeys.push(id);
          }
        });
      } else {
        newSelectedRowKeys = newSelectedRowKeys.filter(
          key => !relatedVehicleDetailIds.includes(key)
        );
      }
      if (newSelectedRowKeys.length === 0) {
        dispatch(resetSelectedRowKeys());
        dispatch(resetSelectedRowVehicleIds());
        return;
      }
      dispatch(setSelectedRowKeys(newSelectedRowKeys));

      let newSelectedRowVehicleIds = [...selectedRowVehicleIds];
      if (e.target.checked) {
        if (!newSelectedRowVehicleIds.includes(record.vehicleId)) {
          newSelectedRowVehicleIds.push(record.vehicleId);
        }

      } else {
        newSelectedRowVehicleIds = newSelectedRowVehicleIds.filter(

          id => id !== record.vehicleId

        );
      }
      if (newSelectedRowVehicleIds.length == 0) return dispatch(resetSelectedRowVehicleIds());
      dispatch(setSelectedRowVehicleIds(newSelectedRowVehicleIds));
    } catch (error) {
      console.error(error);
    }
  };

  const onSelectAllChange = (e) => {
    if (e.target.checked) {
      const allKeys = customVehicleList.flatMap((item) => [
        item.vehicleDetailId,
        ...(Array.isArray(item.multipleDevice)
          ? item.multipleDevice
            .map(d => d.vehicleDetailId)
            .filter(Boolean)
          : []),
      ]);
      const allProviderTypes = customVehicleList.map((item) => item.providerType);
      dispatch(setSelectedRowKeys(allKeys));

      setSelectedProviderTypes(allProviderTypes);
    } else {
      dispatch(resetSelectedRowKeys());
      setSelectedProviderTypes([]);
    }
    dispatch(setIsSelectCheckAll(e.target.checked));
  };

  useEffect(() => {
    fetchVehicleListData();
    return () => {
      dispatch(resetCurrentLoadVehicleManagement());
      dispatch(resetVehicleLimitWithValueTypes());
    };
  }, [dispatch, selectedUserId, language]);

  useEffect(() => {
    if (customVehicleList && selectedRowKeys) {
      let tempSelectedPlate = '';
      customVehicleList?.filter((vhlist) => {
        const fArr = selectedRowKeys?.filter((srk) => srk === vhlist.vehicleDetailId);
        if (fArr?.length > 0) {
          tempSelectedPlate = vhlist.plate;
        }
      });
      setSelectedPlate(tempSelectedPlate);
    }
  }, [selectedRowKeys, customVehicleList]);

  useEffect(() => {
    if (statusList) {
      setStatus(
        Object.entries(statusList).map(([key, value]) => ({
          key: key,
          value: value,
        })),
      );
    }
  }, [statusList]);

  useEffect(() => {
    if (providerList) {
      setProviders(
        Object.entries(providerList).map(([key, value]) => ({
          key: key,
          value: value,
        })),
      );
    }
  }, [providerList]);

  useEffect(() => {
    if (deviceList) {
      setDevices(
        Object.entries(deviceList).map(([key, value]) => ({
          key: key,
          value: value,
        })),
      );
    }
  }, [deviceList]);

  useEffect(() => {
    if (limitTypeList) {
      setLimitTypes(
        Object.entries(limitTypeList).map(([key, value]) => ({
          key: key,
          value: value,
        })),
      );
    }
  }, [limitTypeList]);

  useEffect(() => {
    try {
      if (limitValueTypeList) {
        setLimitValueTypes(
          Object.entries(limitValueTypeList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [limitValueTypeList]);

  const dataSourceWithId = customVehicleList.map((item, index) => ({
    ...item,
    id: index + 1, // index + 1 kullanarak sıfırdan başlamayan bir id ataması yapıyoruz
  }));

  useEffect(() => {
    setPanels([
      {
        setList: setFilteredPlate,
        text: plateFilterText,
        initialList: plateList,
        key: 'plateList',
        input: true,
        defaultValue: filterPlate,
        trim: true,
      },
      {
        setList: setFilteredDriver,
        text: driverFilterText,
        initialList: driverNameSurnameList,
        key: 'driverNameSurnameList',
        input: true,
        defaultValue: filterDriver,
      },
      {
        list: checkedLimitTypes,
        setList: setCheckedLimitTypes,
        text: limitTypeFilterText,
        initialList: limitTypes,
        key: 'limitTypes',
      },
      {
        list: checkedLimitValueTypes,
        setList: setCheckedLimitValueTypes,
        text: limitValueTypeFilterText,
        initialList: limitValueTypes,
        key: 'limitValueTypes',
      },
      {
        list: checkedDevices,
        setList: setCheckedDevices,
        text: deviceTypeFilterText,
        initialList: devices,
        key: 'devices',
      },
      {
        list: checkedProviders,
        setList: setCheckedProviders,
        text: providerFilterText,
        initialList: providers,
        key: 'providers',
      },
      {
        list: checkedStatus,
        setList: setCheckedStatus,
        text: statusFilterText,
        initialList: status,
        key: 'status',
      },
    ]);
  }, [
    status,
    checkedLimitValueTypes,
    checkedDevices,
    checkedProviders,
    checkedStatus,
    checkedLimitTypes,
    filterPlate,
    filterDriver,
    plateFilterText,
    driverFilterText,
    limitTypeFilterText,
    limitValueTypeFilterText,
    deviceTypeFilterText,
    providerFilterText,
    statusFilterText,
  ]);

  const calculateProgress = (totalLimit, remainingLimit) => {
    if (totalLimit === null || remainingLimit == null) {
      return 100;
    }

    const percentage = (remainingLimit / totalLimit) * 100;
    return percentage > 100 ? 100 : 100 - percentage;
  };

  const showLimitsListModal = (record = null) => {
    if (record?.vehicleId) {
      setSingleRecord({
        providerType: record.providerType,
        plate: record.plate,
        vehicleDetailId: record.vehicleDetailId,
      });
    }
    setIsLimitsListModalVisible(true);
  };

  const handleLimitsListOk = () => {
    setSingleRecord(null);
    setIsLimitsListModalVisible(false);
  };

  const handleLimitsListCancel = () => {
    setSingleRecord(null);
    setIsLimitsListModalVisible(false);
  };

  const showUsableDaysModal = () => {
    setIsUsableDaysModalVisible(true);
  };

  const handleUsableDaysOk = () => {
    setIsUsableDaysModalVisible(false);
    setTimeout(async () => {
      fetchVehicleListData();
    }, 1500);
  };

  const handleUsableDaysCancel = () => {
    setIsUsableDaysModalVisible(false);
  };
  const showDownloadFileModal = () => {
    setDownloadFileModalVisible(true);
  };

  const handleRemoveDays = () => {
    const htmlContent = (
      <p>
        <CustomText t="ofSelectedVehicles" />{' '}
        <b className="modal-html-content">
          <CustomText t="theRestrictionOnDaysClosedForFuelPurchase" />
        </b>{' '}
        <CustomText t="andTheseVehiclesFromYourFleet" /> <b className="modal-html-content"><CustomText t="everyDay" /></b>{' '}
        <CustomText t="theyWillBeAbleToPurchaseFuelDo" />
      </p>
    );
    confirmDialog({
      title: attentionText,
      htmlContent: htmlContent,
      okText: yesText,
      cancelText: noText,
      onOk: async () => {
        try {
          const request = {
            vehicleDetailIds: selectedRowKeys,
            usableDays: '1111111',
            plate: selectedPlate,
          };
          const response = await dispatch(getUpdateVehiclesUsableDays({ request })).unwrap();

          if (response.isSuccess) {
            api.success({
              message: removeDayRestrictionText,
              description: transactionSuccessfullyCompletedText,
              duration: 2,
            });
          }
          await dispatch(resetSelectedRowKeys());
        } catch (error) {
          console.log('Validate Failed:', error);
        }
      },
    });
  };

  const handleRemovePlate = (record = null) => {
    const htmlContent = record?.vehicleId ? (
      <p>
        <b className="modal-html-content">{record.plate}</b> <CustomText t="ofTheVehicleWithLicensePlate" />{' '}
        <b className="modal-html-content"><CustomText t="allDevicesWillBeCancelled" /></b> <CustomText t="andThisLicensePlateFromYourFleet" />{' '}
        <b className="modal-html-content"><CustomText t="permanently" /></b> <CustomText t="willBeDeletedDoYouWantToContinue" />
      </p>
    ) : (
      <p>
        <CustomText t="onSelectedVehicles" />{' '}
        <b className="modal-html-content"><CustomText t="allDevicesWillBeCancelled" /></b> <CustomText t="andTheseVehiclesFromYourFleet" />{' '}
        <b className="modal-html-content"><CustomText t="permanently" /></b> <CustomText t="willBeDeletedDoYouApproveYourTransaction" />
      </p>
    );
    confirmDialog({
      title: attentionText,
      htmlContent: htmlContent,
      okText: yesText,
      cancelText: noText,
      onOk: async () => {
        try {
          const request = {
            vehicleIds: record?.vehicleId ? [record?.vehicleId] : selectedRowVehicleIds,
            plate: record?.vehicleId ? record.plate : selectedPlate,
            customerId: selectedCustomer?.customerId,
          };
          const response = await dispatch(deletePlateAllDevices({ request })).unwrap();

          if (response.isSuccess) {
            api.success({
              message: deleteLicensePlateFromFleetText,
              description: transactionSuccessfullyCompletedText,
              duration: 2,
            });
          }
          await dispatch(resetSelectedRowKeys());
          if (isAdmin && selectedUserId) {
            await dispatch(getVehicleList({ customerId: selectedUserId }));
          } else {
            await dispatch(getVehicleList());
          }
        } catch (error) {
          console.log('Validate Failed:', error);
        }
      },
    });
  };

  const handleStopFuel = () => {
    confirmDialog({
      title: attentionText,
      htmlContent: allSelectedPlatesFuelPurchaseWillBeStoppedText,
      okText: yesText,
      cancelText: noText,
      onOk: async () => {
        try {
          const vehicleIdList = customVehicleList.filter(
            (item) => selectedRowKeys.filter((srk) => srk === item.vehicleDetailId).length > 0,
          );
          const selectedDisableVehicleList = customVehicleList
            ?.filter(
              (item) => vehicleIdList.filter((vIl) => vIl.vehicleId === item.vehicleId).length > 0,
            )
            .map((item) => item.vehicleDetailId);

          const request = {
            vehicleDetailIds: selectedDisableVehicleList,
            isDisabled: true,
            plate: selectedPlate,
            isSingleDevice: vehicleIdList?.length <= 1,
          };
          const response = await dispatch(getUpdateVehicleDisable({ request })).unwrap();

          if (response.isSuccess) {
            api.success({
              message: stopFuelPurchase2Text,
              description: transactionSuccessfullyCompletedText,
              duration: 2,
            });
          }
          await dispatch(resetSelectedRowKeys());
          if (isAdmin && selectedUserId) {
            await dispatch(getVehicleList({ customerId: selectedUserId }));
          } else {
            await dispatch(getVehicleList());
          }
        } catch (error) {
          console.log('Validate Failed:', error);
        }
      },
    });
  };

  const handleOpenFuel = () => {
    confirmDialog({
      title: attentionText,
      htmlContent: allSelectedPlatesFuelPurchaseWillBeOpenedText,
      okText: yesText,
      cancelText: noText,
      onOk: async () => {
        try {
          const vehicleIdList = customVehicleList.filter(
            (item) => selectedRowKeys.filter((srk) => srk === item.vehicleDetailId).length > 0,
          );
          const selectedDisableVehicleList = customVehicleList
            ?.filter(
              (item) => vehicleIdList.filter((vIl) => vIl.vehicleId === item.vehicleId).length > 0,
            )
            .map((item) => item.vehicleDetailId);

          const request = {
            vehicleDetailIds: selectedDisableVehicleList,
            isDisabled: false,
            plate: selectedPlate,
            isSingleDevice: vehicleIdList?.length <= 1,
          };
          const response = await dispatch(getUpdateVehicleDisable({ request })).unwrap();

          if (response.isSuccess) {
            api.success({
              message: openFuelPurchase2Text,
              description: transactionSuccessfullyCompletedText,
              duration: 2,
            });
          }
          await dispatch(resetSelectedRowKeys());
          if (isAdmin && selectedUserId) {
            await dispatch(getVehicleList({ customerId: selectedUserId }));
          } else {
            await dispatch(getVehicleList());
          }
        } catch (error) {
          console.log('Validate Failed:', error);
        }
      },
    });
  };

  const handleRemoveLimit = () => {
    const htmlContent = (
      <p>
        <CustomText t="ofTheVehiclesYouSelected" /> <b className="modal-html-content"><CustomText t="fuelPurchaseLimitsWillBeRemoved" /></b>{' '}
        <CustomText t="andTheseVehicles" />{' '}
        <b className="modal-html-content">
          <CustomText t="unlimitedWithinYourFleetLimit" />
        </b>{' '}
        <CustomText t="theyWillBeAbleToPurchaseFuelDo2" />
      </p>
    );
    confirmDialog({
      title: attentionText,
      htmlContent: htmlContent,
      okText: yesText,
      cancelText: noText,
      onOk: async () => {
        try {
          const request = {
            vehicleDetailIds: selectedRowKeys,
            plate: selectedPlate,
          };
          const response = await dispatch(removeLimitRestriction({ request })).unwrap();

          if (response.isSuccess) {
            api.success({
              message: removeLimitRestriction2Text,
              description: transactionSuccessfullyCompletedText,
              duration: 2,
            });
          }
          await dispatch(resetSelectedRowKeys());
          if (isAdmin && selectedUserId) {
            await dispatch(getVehicleList({ customerId: selectedUserId }));
          } else {
            await dispatch(getVehicleList());
          }
        } catch (error) {
          console.log('Validate Failed:', error);
        }
      },
    });
  };

  const onMenuClick = async (record, { key }) => {
    switch (key) {
      case '1':
        await dispatch(setVehicleManagementItem(record));
        history.push({
          pathname: isAdmin
            ? `/admin/ticket-car/management-car-processes/detail/${record.vehicleId}`
            : `/ticket-car/vehicle-management/${record.vehicleId}`,
          state: record,
        });
        break;

      case '2':
        showLimitsListModal(record);
        break;

      case '3':
        handleRemovePlate(record);
        break;

      default:
        console.error('Unknown action key:', key);
    }
  };

  const menuPlate = (record) => (
    <Menu onClick={(key) => onMenuClick(record, key)} className="custom-dropdown-menu">
      <Menu.Item key="1" className="custom-dropdown-item">
        <CustomImage src={plateDetail} />
        <CustomText t="goToLicensePlateDetail" />
      </Menu.Item>
      <Menu.Item key="2" className="custom-dropdown-item">
        <CustomImage src={plateUpdate} />
        <CustomText t="updateLimitInformation" />
      </Menu.Item>
      <Menu.Item key="3" className="custom-dropdown-item">
        <CustomImage src={plateRemove} />
        <CustomText t="deleteLicensePlateFromFleet" />
      </Menu.Item>
    </Menu>
  );

  const menuExtra = () => (
    <Menu className="custom-dropdown-menu">
      <Menu.Item
        key="4"
        className="custom-dropdown-item"
        onClick={showLimitsListModal}
        disabled={selectedRowKeys.length === 0}
      >
        <CustomImage src={limitAdd} />
        <CustomText t="addLimitRestriction" />
      </Menu.Item>
      <Menu.Item
        key="5"
        className="custom-dropdown-item"
        onClick={handleRemoveLimit}
        disabled={selectedRowKeys.length === 0}
      >
        <CustomImage src={limitRemove} />
        <CustomText t="removeLimitRestriction" />
      </Menu.Item>
      <Menu.Item
        key="6"
        className="custom-dropdown-item"
        onClick={showUsableDaysModal}
        disabled={selectedRowKeys.length === 0}
      >
        <CustomImage src={dayAdd} />
        <CustomText t="addDayRestriction" />
      </Menu.Item>
      <Menu.Item
        key="7"
        className="custom-dropdown-item"
        onClick={handleRemoveDays}
        disabled={selectedRowKeys.length === 0}
      >
        <CustomImage src={dayRemove} />
        <CustomText t="removeDayRestriction" />
      </Menu.Item>
      <Menu.Item
        key="8"
        className="custom-dropdown-item"
        onClick={handleRemovePlate}
        disabled={selectedRowKeys.length === 0}
      >
        <CustomImage src={plateRemove} />
        <CustomText t="deleteLicensePlateFromFleet" />
      </Menu.Item>
      <Menu.Item
        key="9"
        className="custom-dropdown-item"
        onClick={handleStopFuel}
        disabled={selectedRowKeys.length === 0}
      >
        <CustomImage src={gasStation} />
        <CustomText t="stopFuelPurchase" />
      </Menu.Item>
      <Menu.Item
        key="11"
        className="custom-dropdown-item"
        onClick={handleOpenFuel}
        disabled={selectedRowKeys.length === 0}
      >
        <CustomImage src={gasStation} />
        <CustomText t="openFuelPurchase" />
      </Menu.Item>
      <Menu.Item key="10" className="custom-dropdown-item" onClick={showDownloadFileModal}>
        <CustomImage src={documentDownload} />
        <CustomText t="downloadVehicleList" />
      </Menu.Item>
    </Menu>
  );

  const handleExpand = useCallback((rowKey) => {
    setExpandedRowKeys((expandedRows) => {
      if (expandedRows.includes(rowKey)) {
        return expandedRows.filter((id) => id !== rowKey);
      }
      return [...expandedRows, rowKey];
    });
  }, []);

  const getRemainLimit = (record) => {
    const { limitValueType, limitAmount, limitRemainingAmount } = record;
    return (
      <Progress
        data-testid="progress-bar-test-id"
        percent={calculateProgress(limitAmount, limitRemainingAmount)}
        showInfo={true}
        strokeColor="#049ac6"
        strokeWidth={11}
        trailColor="#f1f5f9"
        format={() => {
          if (!limitAmount) {
            return unlimited;
          }
          return limitValueType === 2 ? `${limitAmount} lt.` : `${moneyFormat(limitAmount)}₺`;
        }}
      />
    );
  };
  useEffect(() => {
    let tempColumns = [
      {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        align: 'center',
        width: 40,
        height: 50,
        render: (_, record) => (
          <span
            className={`custom-id-column ${expandedRowKeys?.includes(record.id) ? 'vehicle-management-expand-circle' : ''
              }`}
          >
            {record?.id}
          </span>
        ),
      },
      {
        title: (
          <Checkbox
            checked={isSelectCheckAll}
            indeterminate={indeterminate}
            onChange={onSelectAllChange}
          />
        ),
        key: 'selection',
        render: (text, record) => (
          <Checkbox
            checked={selectedRowKeys?.includes(record.vehicleDetailId)}
            onChange={(e) => onSelectChange(e, record)}
          />
        ),
        width: 30,
        fixed: 'left',
      },
      {
        title: <CustomText t="licensePlate" />,
        dataIndex: 'plate',
        key: 'plate',
        align: 'left',
        width: 90,
        height: 50,
        className: 'custom-plate-column',
        render: (text) => formatPlate(text),
      },
    ];
    if (isMobil) {
      tempColumns = tempColumns.concat([
        {
          title: <CustomText t="provider2" />,
          dataIndex: 'provider',
          key: 'provider',
          align: 'left',
          width: 80,
          height: 50,
          render: (_, record) => {
            const vouId = record.providerType;
            const IconComponent = CustomIconComponent({ providerType: vouId });
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {IconComponent && (
                  <img
                    src={IconComponent}
                    alt={record.provider}
                    style={{ width: 24, height: 24, marginRight: 8 }}
                  />
                )}
                <p style={{ marginTop: 15 }}>{record.provider}</p>
              </div>
            );
          },
        },
        {
          title: <CustomText t="status" />,
          dataIndex: 'isDisabled',
          key: 'isDisabled',
          align: 'left',
          width: 108,
          height: 50,
          render: (_, record) => (
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                fontFamily: 'UbuntuRegular, sans-serif',
                color: record.isDisabled ? '#94a3b8' : 'initial',
                fontSize: '12px',
              }}
            >
              <Badge
                color={record.isDisabled ? 'red' : 'green'}
                style={{ marginLeft: '5px' }}
              ></Badge>
              {record.isDisabled ? <CustomText t="passive" /> : <CustomText t="active2" />}
              <CustomImage
                dataTestId="handleExpand-test-id"
                style={{ marginLeft: 10, width: 24, height: 24, flexGrow: 0, cursor: 'pointer' }}
                src={expandedRowKeys?.includes(record.id) ? icnUp : icnDown}
                onClick={() => handleExpand(record.id)}
              />
            </span>
          ),
        },
      ]);
    } else {
      tempColumns = tempColumns.concat([
        {
          title: <CustomText t="driver2" />,
          dataIndex: 'driverNameSurname',
          key: 'driverNameSurname',
          align: 'left',
          sorter: true,
          width: 110,
          height: 50,
        },
        {
          title: <CustomText t="limitType5" />,
          dataIndex: 'limitTypeLabel',
          key: 'limitTypeLabel',
          align: 'left',
          width: 80,
          height: 50,
        },
        {
          title: <CustomText t="limitType6" />,
          dataIndex: 'limitValueTypeLabel',
          key: 'limitValueTypeLabel',
          align: 'left',
          width: 90,
          height: 50,
          render: (_, record) => {
            return !record?.limitAmount ? '' : record?.limitValueTypeLabel;
          },
        },
        {
          title: <CustomText t="remainingLimit3" />,
          dataIndex: 'limitValueType',
          key: 'limitValueType',
          align: 'left',
          width: 160,
          height: 50,
          render: (_, record) => getRemainLimit(record),
        },
        {
          title: <CustomText t="deviceType4" />,
          dataIndex: 'deviceTypeLabel',
          key: 'deviceTypeLabel',
          align: 'left',
          width: 85,
          height: 50,
          render: (_, record) => {
            return record?.multipleDevice ? (
              <CustomText t="multipleDevice" />
            ) : (
              <CustomText t={record?.deviceTypeLabel} />
            );
          },
        },
        {
          title: <CustomText t="provider2" />,
          dataIndex: 'provider',
          key: 'provider',
          align: 'left',
          width: 90,
          height: 50,
          render: (_, record) => {
            const vouId = record.providerType;
            const IconComponent = CustomIconComponent({ providerType: vouId });
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {IconComponent && (
                  <img
                    src={IconComponent}
                    alt={record.provider}
                    style={{ width: 24, height: 24, marginRight: 8 }}
                  />
                )}
                <p style={{ marginTop: 15 }}>{record.provider}</p>
              </div>
            );
          },
        },
        {
          title: <CustomText t="status" />,
          dataIndex: 'isDisabled',
          key: 'isDisabled',
          align: 'left',
          width: 90,
          height: 50,
          render: (isDisabled) => (
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                fontFamily: 'UbuntuRegular, sans-serif',
                color: isDisabled ? '#94a3b8' : 'initial',
                fontSize: '12px',
              }}
            >
              <Badge color={isDisabled ? 'red' : 'green'} style={{ marginLeft: '5px' }}></Badge>
              {isDisabled ? <CustomText t="passive" /> : <CustomText t="active2" />}
            </span>
          ),
        },
        {
          title: <CustomText t="transactions2" />,
          key: 'actions',
          align: 'left',
          width: 70,
          height: 50,
          render: (text, record) => (
            <Dropdown overlay={menuPlate(record)} trigger={['click']}>
              <Button
                type="text"
                icon={<CustomImage src={rowDetail} />}
                style={{
                  borderRadius: '0',
                  padding: '0',
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 'auto',
                  height: 'auto',
                }}
              />
            </Dropdown>
          ),
        },
      ]);
    }
    setColumns(tempColumns);
  }, [isMobil, expandedRowKeys, selectedRowKeys]);

  const clickFilter = async () => {
    try {
      const filter = {
        providerIds: checkedProviders?.map((it) => parseInt(it, 10)),
        statusIds: checkedStatus?.map((it) => parseInt(it, 10)),
        deviceIds: checkedDevices?.map((it) => parseInt(it, 10)),
        limitTypeIds: checkedLimitTypes?.map((it) => parseInt(it, 10)),
        limitValueTypeIds: checkedLimitValueTypes?.map((it) => parseInt(it, 10)),
        plate: filterPlate,
        driverNameSurname: filterDriver,
      };
      let req = { filter };
      if (isAdmin && selectedUserId) {
        req.customerId = parseInt(selectedUserId, 10);
      }
      await dispatch(getVehicleList({ data: req }));
    } catch (error) {
      console.error(error);
    }
  };

  const clearFilter = () => {
    try {
      setCheckedStatus([]);
      setCheckedProviders([]);
      setCheckedLimitValueTypes([]);
      setCheckedLimitTypes([]);
      setCheckedDevices([]);
      setFilteredDriver('');
      setFilteredPlate('');
      fetchVehicleListData();
    } catch (error) {
      console.error(error);
    }
  };

  const listenClickCheckbox = (setList, tempList) => {
    setList(tempList);
  };

  const downloadBPPO = async () => {
    const data = await vehicleManagementServices.downloadActivationCodeForBP({
      customerId: selectedCustomer?.customerId,
    });
    download(data, `BPActivation.xlsx`);
  };

  const FilterMenu = () => (
    <div className="custom-filter-menu" data-testid="filter-menu-test-id">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="custom-filter-menu-filtrele"><CustomText t="filter2" /></span>
        <button
          data-testid="clear-filters-button"
          onClick={clearFilter}
          className="custom-filter-menu-clear"
        >
          <CustomText t="clean" /></button>
      </div>

      <CustomFilterCollapse panels={panels} listenClickCheckbox={listenClickCheckbox} />

      <Button
        type="primary"
        onClick={clickFilter}
        block
        className="custom-filter-menu-filter-button"
      >
        <CustomImage src={filterButton} /> <CustomText t="filter2" />
      </Button>
    </div>
  );

  function expandedRowRender(record) {
    return (
      <div className="vehicle-management-expand">
        <div className="vehicle-management-expand-line" />
        <div className="vehicle-management-expand-main-div " style={{ flex: 1 }}>
          <div className="vehicle-management-expand-div">
            <span className="vehicle-management-expand-head"><CustomText t="driver" /></span>
            <span className="vehicle-management-expand-text">{record?.driverNameSurname}</span>
          </div>
          <div className="vehicle-management-expand-div">
            <span className="vehicle-management-expand-head"><CustomText t="limitType3" /></span>
            <span className="vehicle-management-expand-text">{record?.limitTypeLabel}</span>
          </div>
          <div className="vehicle-management-expand-div">
            <span className="vehicle-management-expand-head"><CustomText t="limitType2" /></span>
            <span className="vehicle-management-expand-text">
              {!record?.limitAmount ? '' : record?.limitValueTypeLabel}
            </span>
          </div>
          <div className="vehicle-management-expand-div">
            <span className="vehicle-management-expand-head"><CustomText t="remainingLimit" /></span>
            <div style={{ flex: 1 }}>{getRemainLimit(record)}</div>
          </div>
          <div className="vehicle-management-expand-div">
            <span className="vehicle-management-expand-head"><CustomText t="deviceType2" /></span>
            <span className="vehicle-management-expand-text">
              <CustomText t={record?.deviceTypeLabel} />
            </span>
          </div>
          <button
            className="vehicle-management-expand-div"
            style={{ cursor: 'pointer', marginTop: 5 }}
            tabIndex={0}
            onClick={() => onMenuClick(record, { key: '1' })}
          >
            <CustomImage src={plateDetail} />
            <span
              className="vehicle-management-expand-text"
              style={{ textDecoration: 'underline', fontSize: 14 }}
            >
              <CustomText t="goToLicensePlateDetail" />
            </span>
          </button>
          <button
            className="vehicle-management-expand-div"
            style={{ cursor: 'pointer' }}
            onClick={() => onMenuClick(record, { key: '2' })}
            tabIndex={0}
          >
            <CustomImage src={plateUpdate} />
            <span
              className="vehicle-management-expand-text"
              style={{ textDecoration: 'underline', fontSize: 14 }}
            >
              <CustomText t="updateLimitInformation" />
            </span>
          </button>
          <button
            className="vehicle-management-expand-div"
            style={{ cursor: 'pointer' }}
            onClick={() => onMenuClick(record, { key: '3' })}
            tabIndex={0}
          >
            <CustomImage src={plateRemove} />
            <span
              className="vehicle-management-expand-text"
              style={{ textDecoration: 'underline', fontSize: 14 }}
            >
              <CustomText t="deleteLicensePlateFromFleet" />
            </span>
          </button>
        </div>
      </div>
    );
  }

  const goToUTTSBrief = () => {
    warningDialog({
      title: (
        <div className="utts-modal-1-head">
          <span className="utts-modal-1-head-text" style={{ width: 480 }}>
            <CustomText t="vehiclesWithUttsDeviceInstalledWillBeNotified" />
          </span>
        </div>
      ),
      width: 590,
      notWarnIcon: true,
      okText: completeUttsNotificationText,
      cancelText: giveUpText,
      className: 'not-show-warning-buttons',
      okButtonProps: 'not-show-warning-buttons',
      htmlContent: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className="vehicle-utts-modal-1-area2">
            <CustomImage src={iconDanger} />
            <span
              className="vehicle-utts-modal-1-area1-text"
              style={{ alignItems: 'center', marginTop: 5, fontSize: 14 }}
            >
              <CustomText t="youSelectedFromYourFleet" />{' '}
              <b className="utts-bold">{selectedRowKeys.length} araca</b>{' '}
              <CustomText t="notificationThatUttsDeviceIsInstalledWillBe" />
            </span>
          </div>
          <div style={{ display: 'flex', marginTop: 20, flexDirection: 'column' }}>
            <span className="vehicle-utts-modal-1-area1-text" style={{ textAlign: 'center' }}>
              <CustomText t="thisProcessInvolvesAddingTheVehiclesInQuestion" />{' '}
              <b className="utts-bold"><CustomText t="withUttsDevice" /> </b>
            </span>
            <span className="vehicle-utts-modal-1-area1-text" style={{ textAlign: 'center' }}>
              {' '}
              <b className="utts-bold"><CustomText t="willBeRegistered" /></b>{' '}
              <CustomText t="andGasStations" />{' '}
              <b className="utts-bold"><CustomText t="toBeAbleToPurchaseFuel" /></b>{' '}
              <CustomText t="enablesPeriod" />
            </span>
          </div>
          <button className="utts-ok-button" onClick={processUTTSDevice}>
            <CustomText t="completeUttsNotification" />
          </button>
          <button className="utts-cancel-button" onClick={() => null}>
            <CustomText t="giveUp" /></button>
        </div>
      ),
    });
  };

  const processUTTSDevice = async () => {
    try {
      const result = await vehicleManagementServices.createUTTSVehicles({
        customerId: isAdmin && selectedUserId ? selectedUserId : selectedCustomer?.customerId,
        vehicleIds: selectedRowVehicleIds,
      });
      if (result.isSuccess) UTTSSuccessModal();
      else UTTSErrorModal(processUTTSDevice);
    } catch (error) {
      console.error(error);
    }
  };

  const UTTSSuccessModal = () => {
    try {
      setTimeout(async () => {
        fetchVehicleListData();
        dispatch(resetSelectedRowKeys());
        setSelectedProviderTypes([]);
      }, 100);
    } catch (error) {
      console.error(error);
    }
    successDialog({
      title: (
        <div className="utts-modal-1-head">
          <span className="utts-modal-1-head-text"><CustomText t="successful" /></span>
        </div>
      ),
      htmlContent: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <b
            className="vehicle-utts-modal-1-area1-text utts-bold"
            style={{ textAlign: 'center', marginTop: 5, fontSize: 20 }}
          >
            <CustomText t="uttsNotificationSuccessfullyCompleted" />
          </b>
          <div style={{ display: 'flex', marginTop: 20, flexDirection: 'column' }}>
            <span className="vehicle-utts-modal-1-area1-text" style={{ textAlign: 'center' }}>
              <CustomText t="youSelectedFromYourFleet" />{' '}
              <b className="utts-bold">
                {selectedRowKeys.length} <CustomText t="uttsDeviceTtbHasBeenSuccessfullyDefinedFor" />
              </b>{' '}
              <CustomText t="yourVehiclesCanStartPurchasingFuelFromUtts" />
            </span>
          </div>
        </div>
      ),
    });
  };

  const content = () => {
    return loading.vehicleList ? (
      <VehicleManagementSkeleton />
    ) : (
      <>
        {contextHolder}
        <div className="vehicle-management" data-testid="vehicle-management-loading-id">
          {isAdmin && (
            <div className="summary-container">
              <div className="summary-info">
                <div className="transaction-icon" style={{ backgroundColor: '#cafaf0' }}>
                  <CustomImage src={filoCode} />
                </div>
                <div className="summary-right-section">
                  <span className="summary-subinfo"><CustomText t="fleetCode" /></span>
                  <span className="summary-status">{externalId}</span>
                </div>
              </div>
            </div>
          )}

          {cusVouList?.filter(
            (item) =>
              (isAdmin ? selectedUserId : selectedCustomer?.customerId ?? '').toString() ===
              item.customerId.toString() && item.patId === 1,
          )?.length > 0 && (
              <div className="summary-container">
                <div className="summary-info">
                  <div className="transaction-icon">
                    <CustomImage src={carWallet} />
                  </div>
                  <div className="summary-right-section">
                    <span className="summary-subinfo"><CustomText t="totalFleetLimit" /></span>
                    <span className="summary-status">{moneyFormat(vehicleLimit)}₺</span>
                  </div>
                </div>
              </div>
            )}
          {/*!cusVouList?.filter(
            (item) =>
              (isAdmin ? selectedUserId : selectedCustomer?.customerId ?? '').toString() ===
                item.customerId.toString() && item.patId === 2,
          )?.length > 0 && (
            <div className="summary-container">
              <div className="summary-info">
                <div className="transaction-icon" style={{ backgroundColor: '#ffeeed' }}>
                  <CustomImage src={carMoney} />
                </div>
                <div className="summary-right-section">
                  <span className="summary-subinfo">Filo Kalan Limit</span>
                  <span className="summary-status">{moneyFormat(vehicleAvailableLimit)}₺</span>
                </div>
              </div>
            </div>
          )*/}
          <div className="summary-container">
            <div className="summary-info">
              <div className="transaction-icon" style={{ backgroundColor: '#ffeeed' }}>
                <CustomImage src={carMoney} />
              </div>
              <div className="summary-right-section">
                <span className="summary-subinfo"><CustomText t="fleetRemainingLimit" /></span>
                <span className="summary-status">{moneyFormat(vehicleAvailableLimit)}₺</span>
              </div>
            </div>
          </div>

          <div className="summary-container">
            <div className="summary-info">
              <div className="transaction-icon" style={{ backgroundColor: '#d1fadf' }}>
                <CustomImage src={car} />
              </div>
              <div className="summary-right-section">
                <span className="summary-subinfo"><CustomText t="activeVehicle" /></span>
                <span className="summary-status">
                  {activeVehicles}/{activeVehicles + passiveVehicles}
                </span>
              </div>
            </div>
          </div>
          {IsBpCustomer && IsBpCustomer !== 0 ? (
            <div
              className="summary-container"
              style={{ backgroundColor: '#00a483', color: '#fff' }}
            >
              <div className="summary-info">
                <div className="transaction-icon" style={{ backgroundColor: '#fff' }}>
                  <CustomImage src={poLOGO} style={{ width: 36, marginLeft: -5 }} />
                </div>
                <div
                  className="summary-right-section"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  <span className="summary-subinfo" style={{ width: 120, color: '#fff' }}>
                    <CustomText t="petrolOfisiActivationCodes" />
                  </span>
                  <button className="vehicle-management-po-bp-button" onClick={downloadBPPO}>
                    <CustomImage src={downloadPO} />
                    <CustomText t="download" /></button>
                </div>
              </div>
            </div>
          ) : null}
          {cusVouList?.filter(
            (item) =>
              (isAdmin ? selectedUserId : selectedCustomer?.customerId ?? '').toString() ===
              item.customerId.toString() && item.patId === 2,
          )?.length > 0 && (
              <div
                className="summary-container"
                style={{ backgroundColor: 'transparent', borderWidth: 0 }}
              ></div>
            )}
        </div>

        <div className="balance-report-header-tools"></div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 20,
          }}
        >
          <button
            className="vehicle-management-top-button-area"
            onClick={() => (selectedRowKeys.length === 0 ? null : goToUTTSBrief())}
          >
            {selectedRowKeys.length !== 0 ? (
              <CustomText t="makeUttsNotification" />
            ) : (
              <Tooltip
                title={
                  <div className="utts-tooltip">
                    <span className="utts-tooltip-text">
                      <CustomText t="pleaseSelectAVehicleToMakeUttsNotification" />
                    </span>
                  </div>
                }
                color="transparent"
                placement="bottom"
                arrowPointAtCenter={true}
                trigger={'click'}
              >
                <CustomText t="makeUttsNotification" />
              </Tooltip>
            )}

            <Tooltip
              title={
                <div className="utts-tooltip">
                  <CustomImage src={iconBilgiSvg} style={{ width: 32, height: 32 }} />
                  <span className="utts-tooltip-text">
                    <CustomText t="byDeclaringThatUttsDevicesHaveBeenInstalled" />
                  </span>
                </div>
              }
              color="transparent"
              placement="bottom"
              arrowPointAtCenter={true}
            >
              {''}
              <CustomImage src={iconBilgiSvg} />
            </Tooltip>
          </button>
          {cusVouList?.filter(
            (item) =>
              (isAdmin ? selectedUserId : selectedCustomer?.customerId ?? '').toString() ===
              item.customerId.toString() &&
              item.patId === 2 &&
              item.pamId === 4,
          )?.length > 0 ? (
            <button className="vehicle-management-top-button-area" onClick={goToAddFleetLimit}>
              <CustomText t="increaseFleetLimit" />
            </button>
          ) : null}
          <button className="vehicle-management-top-button-area" onClick={goToAddNewCar}>
            <CustomImage
              dataTestId="goToAddNewCar-test-id"
              src={plus}
              style={{ cursor: 'pointer' }}
            />
            <CustomText t="addNewVehicle" />
          </button>
        </div>
        <div className="balance-report-header-tools"></div>
        <Card
          title={<CustomText t="vehicles" />}
          className="balance-list-container"
          headStyle={{ fontFamily: 'UbuntuRegular', fontSize: '18px', fontWeight: 'bolder' }}
          extra={
            <div className="balance-tools">
              {/*<div className="header-notification">
                <CustomImage
                  dataTestId="goToAddNewCar-test-id"
                  src={plus}
                  style={{ cursor: 'pointer' }}
                  onClick={goToAddNewCar}
                />
              </div>*/}
              <div className="header-notification" style={{ backgroundColor: 'transparent' }}></div>
              <div className="header-notification" data-testid="filter-test-id">
                <Dropdown overlay={<FilterMenu />} trigger={['click']}>
                  <Button
                    type="text"
                    icon={<CustomImage src={iconSetting} />}
                    style={{
                      borderRadius: '0',
                      padding: '0',
                      backgroundColor: 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 'auto',
                      height: 'auto',
                    }}
                  />
                </Dropdown>
              </div>
              <div className="header-notification">
                <Dropdown overlay={menuExtra()} trigger={['click']}>
                  <Button
                    data-testid="extra-menu-test-id"
                    type="text"
                    icon={<CustomImage src={more} />}
                    style={{
                      borderRadius: '0',
                      padding: '0',
                      backgroundColor: 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 'auto',
                      height: 'auto',
                    }}
                  />
                </Dropdown>
              </div>
            </div>
          }
        >
          <CustomTable
            data-testid="table-test-id"
            pagination={false}
            dataSource={dataSourceWithId}
            columns={columns}
            className="babs-list-table"
            rowKey={(record) => record.id}
            expandedRowKeys={expandedRowKeys}
            expandable={
              isMobil && {
                showExpandColumn: false,
                expandIconColumnIndex: 3,
                onExpand: (expanded, record, key) =>
                  expandedRowKeys === key ? setExpandedRowKeys(null) : setExpandedRowKeys([key]),
                expandedRowRender: expandedRowRender,
              }
            }
          />
        </Card>
        <AddVehicleLimitsListModal
          isVisible={isLimitsListModalVisible}
          handleOk={handleLimitsListOk}
          handleCancel={handleLimitsListCancel}
          vehicleDetailIds={selectedRowKeys}
          plate={selectedPlate}
          providerTypes={selectedProviderTypes}
          singleVehicle={singleRecord}
        />
        <AddVehicleUsableDaysModal
          isVisible={isUsableDaysModalVisible}
          handleOk={handleUsableDaysOk}
          handleCancel={handleUsableDaysCancel}
          plate={selectedPlate}
          vehicleDetailIds={selectedRowKeys}
        />
        <DownloadFileModal
          modalVisible={downloadFileModalVisible}
          handleModalVisible={setDownloadFileModalVisible}
          fileName={getFileNameByLanguage('Arac-Listesi', 'Vehicle-List')}
        />
      </>
    );
  };

  const goToAddFleetLimit = () => {
    try {
      history.push({
        pathname: `/ticket-car/add-fleet-limit`,
      });
    } catch (error) { }
  };

  const goToAddNewCar = () => {
    try {
      if (isAdmin && props.changeActiveTab) {
        props.changeActiveTab('2');
      } else {
        history.push({
          pathname: `/ticket-car/add-car`,
        });
      }
    } catch (error) { }
  };

  return (
    <CustomPageHeader
      data-testid="vehicle-management-test-id"
      title={isAdmin ? null : <CustomText t="vehicleManagement" />}
      showBreadCrumb={!isAdmin}
      showHelpButton={!isAdmin}
      adminCustomHeaderContent={isAdmin ? 'custom-header-content-subpage' : ''}
      routes={['ticketCarHeader']}
    >
      {content()}
    </CustomPageHeader>
  );
};

export default VehicleManagement;
